import type { FetchOptions } from 'ofetch'

export const useApiFetch = (endpoint: string, options?: FetchOptions) => {
  const {
    public: { API_BASE, API_VERSION }
  } = useRuntimeConfig()

  const { addController, removeController } = useAbortController()

  const controller = new AbortController()

  addController(controller)

  const api = $fetch.create({ baseURL: `${API_BASE}/${API_VERSION}`, signal: controller.signal })

  return {
    response: api(endpoint, options).finally(() => removeController(controller)),
    controller
  }
}
